export const page_fallback = {
    requiresAuth: true,
    run: () => { },
};
//# sourceMappingURL=page_fallback.js.map